import { createContext, useContext, useEffect, useState } from "react";
import { STRINGS } from "../lib/i18n";

const PrefsContext = createContext(null);

export function PrefsProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tmg_lang") || "bm");
  const [theme, setTheme] = useState(() => localStorage.getItem("tmg_theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("tmg_theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("tmg_lang", lang);
  }, [lang]);

  return (
    <PrefsContext.Provider value={{ lang, setLang, theme, setTheme, t: STRINGS[lang] }}>
      {children}
    </PrefsContext.Provider>
  );
}

export const usePrefs = () => useContext(PrefsContext);
